/* eslint-disable no-useless-escape */
// noinspection RegExpSimplifiable,RegExpUnnecessaryNonCapturingGroup
// Aligned with validNameRegex from legacy regex.ts
// Structure inherently prevents consecutive spaces/hyphens by requiring a letter after each separator
// U+0027 ASCII apostrophe, U+2018/U+2019 left/right single quotation marks (smart quotes)
export const NAME_REGEX =
    /^[\p{L}][\p{L}'\u2018\u2019.,]*([- ][\p{L}][\p{L}'\u2018\u2019.,]*)*$/u;

// Similar to NAME_REGEX but requires at least one space separator (+ instead of *)
// This forces a space in the middle so we can split first/last name (GROW-2785)
// Hyphens are treated as part of name segments to preserve hyphenated names when splitting
export const FULLNAME_REGEX =
    /^[\p{L}][\p{L}'\u2018\u2019,.-]*([ ][\p{L}][\p{L}'\u2018\u2019,.-]*)+$/u;

export const PHONE_NUMBER_REGEX =
    /(?=(^([a-zA-Z+ ()-]*[0-9][a-zA-Z+ ()-]*){4,24})$)(?=^[-+]?[(]?[a-zA-Z0-9]+[)]?([ -]?[a-zA-Z0-9]+)*([ -]?[(]([\s-]?[a-zA-Z0-9]+)*[)])?$)(?=(?:(?=^.*[a-zA-Z]+.*$)((^.*[ -]+.*[0-9]+.*$)|(^.*[0-9]+.*[- ]+.*$))|(?!(?=^.*[a-zA-Z]+.*$)(^.*$))))(.*)/;

export const EMAIL_REGEX =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
